import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Button from "../../AdminModule/Dashboard/AdminDashboard/Button";
// import ButtonMUI from "@material-ui/core/Button";
import ReactStars from "react-rating-stars-component";
import InputField from "../InputField";
import "./styles.scss";
import { makeStyles } from "@material-ui/core/styles";
import FileUpload from "../FileUpload";
import TextareaField from "../TextAreaField";
import swal from "sweetalert";
import { postSessionSummaryData } from "../../AdminModule/Dashboard/StartupDashboard/dependencies/action";
const useStyles = makeStyles((theme) => ({
  input: {
    backgroundColor: "white",
    padding: "0.5px 0px",
  },
}));
function SessionsMomModal(props) {
  const { postSessionSummaryData, sessionId, mentorshipId } = props;
  const hoursData = [{}];
  const [ratingData, setRatingData] = useState(0);
  const [discussonSummary, setDiscussonSummary] = useState("");
  const [fileData, setFileData] = useState();
  const [sessionHours, setSessionHours] = useState("");
  const classes = useStyles();
  const [wordCounter, setWordCounter] = useState(0);
  const [errorMessagePurpose, setErrorMessagePurpose] = useState(
    "*Please Enter the purpose"
  );
  const [errorVisible, SetErrorVisible] = useState(false);
  const [errorVisible7, SetErrorVisible7] = useState(false);

  const customStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "white",
      minHeight: "45px",
      color: "#333",
      fontSize:"16px"
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isSelected
          ? "#b499c7"
          : isFocused
          ? "#e4d7ee"
          : "white",
        color: isSelected ? "white" : "black",
        cursor: isDisabled ? "not-allowed" : "default",
      };
    },
    menu: (base) => ({
      ...base,
      width: "max-content",
      minWidth: "100%",
      fontSize:"14px"
  }),
  };
  hoursData.push(
    {
      value: "0",
      label: "0.5",
    },
    { value: "1", label: "1" },
    { value: "2", label: "1.5" },
    { value: "3", label: "2" },
    { value: "4", label: "2.5" },
    { value: "5", label: "3" },
    { value: "6", label: "3.5" },
    { value: "7", label: "4" },
    { value: "8", label: "4.5" },
    { value: "9", label: "5" },
    { value: "10", label: "5.5" },
    { value: "11", label: "6" }
  );

  //   const hoursData = ["0.5 hr","1 hr","1.5 hr","2 hrs","2.5 hrs","3 hrs","3.5 hrs","4 hrs","4.5 hrs","5 hrs"]
  const handleClose = () => {
    props.setModalVisibility(false);
  };
  const ratingChanged = (newRating) => {
    setRatingData(newRating);
  };
  const removeFile = (fileType) => {
    if (fileType === "uploadResume") {
      setFileData((user) => {
        return { ...user, ["uploadResume"]: null };
      });
    }
  };
  const testWordLimit = (data) => {
    let value =
      data?.length === 0
        ? 0
        : data
            ?.replace(/(^\s*)|(\s*$)/gi, "")
            ?.replace(/[ ]{2,}/gi, " ")
            ?.split(" ")?.length;
    if (value == 250) {
      setErrorMessagePurpose("Exceeds word limit reached");
      SetErrorVisible7(true);
    } else if (value < 250 && value > 0) {
      SetErrorVisible7(false);
      setErrorMessagePurpose("*Please Enter the purpose");
    } else if (value == 0) {
      SetErrorVisible7(true);
    } else if (value == 251) {
      setWordCounter(250);
      return value;
    }
    setWordCounter(value);
    return value;
  };
  const handleInputChange = (e) => {
    setFileData((user) => {
      return { ...user, [e.target.name]: e.target.files[0] };
    });
    const newFormData = {
      ...fileData,
      [e.target.name]: e.target.files[0],
    };
    // setAppliedFormData(newFormData);
    // postSessionSummaryData()
    // addDraftData(newFormData, "nextdraftbutton")
  };
  const handleSubmit = () => {
    const formData = new FormData();
    if (
      ratingData > 0 &&
      discussonSummary.length > 0 &&
      sessionHours !== "" 
    ) {
      SetErrorVisible(false);
      let params = {
        userId: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
        sessionId: sessionId,
        mentorshipId: mentorshipId,
        sessionFeedback: ratingData,
        discussionSummary: discussonSummary,
        sessionHours: sessionHours,
      };
      formData.append("application", JSON.stringify(params));
      formData.append("uploadSupportingFile", fileData?.uploadResume);
      postSessionSummaryData(formData);
      setTimeout(() => {
        swal({
          title: "Thank You",
          text: `Session Notes Submitted Successfully`,
          icon: "success",
          // timer: 1500,
          // buttons: false,
        }).then(function () {

          // create a state to check status , on Success close modal 21/10/22
          props.parentData(true);
          props.parentData2(true);
          props.setModalVisibility(false);
        });
      }, 500);
    } else {
      SetErrorVisible(true);
    }
  };
  // const firstExample = {
  //   size: 50,
  //   count: 5,
  //   isHalf: false,
  //   marginTop: -13,
  //   paddingLeft: 25,
  //   value: 3,
  //   color: "gray",
  //   activeColor: "orange",
  //   onChange: (newValue) => {
  //     
  //   },
  // };
  const firstExample = {
    size: 35,
    count: 5,
    isHalf: false,
    value: 0,
    color: 'lightgray',
    // boxShadow: '1px 2px 9px #F4AAB9',
    // boxShadow: "-10px 13px 30.5px 0 red",
    activeColor: 'orange',
    // background-image: linear-gradient(#fdc163, #f78f54) !important;
    onChange: (newValue) => {
      setRatingData(newValue);
      // 
    },
  };
  const clickonFileinput = (event) => {
    event.preventDefault();
    let element = document.getElementById("fileUpload-resume");
    element.click();
  };

  return (
    <>
      <div className="modal-dialog modal-dialog-centered">
        <Modal
          size="lg"
          show={props.modalVisibility}
          onHide={() => props.setModalVisibility(false)}
          aria-labelledby="example-modal-sizes-title-lg"
          style={{ borderRadius: "7px" }}
        >
          <Modal.Header className="d-flex ">
            <Modal.Title className="sessionMinutesHeading">SESSION NOTES</Modal.Title>
            <div className="newuserTooltip">
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={handleClose}
            />
            <span className="tooltiptext  close-window" style={{left:"-130px",top:"2px",width:"130px"}}>Close Window</span>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="session-detailsModal">
              <div className="feedback-session2">
                <div className="row pb-4 heightModalFix">
                  <div className="col col-lg-1 col-md-1 col-sm-2 col-12 d-flex justify-content-center">
                    1
                  </div>
                  <div className="col col-lg-4 col-md-5 col-sm-10 col-12 feedback-headdding">
                    SESSION FEEDBACK*
                  </div>
                  <div className="col col-lg-7 col-md-6 col-sm-12  col-12 starsDiv">
                    <ReactStars
                      {...firstExample}
                      half
                      onChange={ratingChanged}
                    />
                  </div>
                </div>
                <div className="row pb-4 ">
                  <div className="col col-lg-1 col-md-1 col-sm-2 col-12 d-flex justify-content-center">
                    2
                  </div>
                  <div className="col col-lg-4 col-md-5 col-sm-10 col-12 feedback-headdding ">
                    DISCUSSION SUMMARY*
                  </div>
                  <div
                    style={{ textAlign: "right" }}
                    className="col col-lg-7 col-md-6 col-sm-12  col-12 discussionSummaryBox"
                  >
                    <TextareaField
                      id="purpose"
                      variant="outlined"
                      placeholder="Describe in maximum 100 words"
                      fullWidth
                      margin="normal"
                      style={{ backgroundColor: "white" }}
                      name="purpose"
                      rows={5}
                      InputProps={{ className: classes.input }}
                      // className="purposeBox"
                      // maxRows={4}
                      value={discussonSummary}
                      onChange={(e) => {
                        if (testWordLimit(e.target.value) < 251) {
                          setDiscussonSummary(e.target.value);
                        }
                      }}
                    />
                    <div className="wordCounter">
                      Word Count: {wordCounter} / 250
                    </div>

                    {errorVisible7 && (
                      <div className="login-error-msg mt-2">
                        {errorMessagePurpose}
                      </div>
                    )}
                    {/* <InputField
                      style={{ fontFamily: "Montserrat" }}
                      fullWidth
                      variant="outlined"
                      type="text"
                      onChange={(e) => {
                        setDiscussonSummary(e.target.value);
                        // setError(null);
                      }}
                      value={discussonSummary}
                    /> */}
                  </div>
                </div>
                <div className="row pb-4 ">
                  <div className="col col-lg-1 col-md-1 col-sm-2 col-12 d-flex justify-content-center">
                    3
                  </div>
                  <div className="col col-lg-4 col-md-5 col-sm-10 col-12 feedback-headdding ">
                    UPLOAD DOCUMENT
                  </div>
                  <div className="fileUpload2 col col-lg-7 col-md-6 col-sm-12 ">
                    <div>
                    <div className="newuserTooltip top-btn">
                      <button
                        onClick={clickonFileinput}
                        className="newUploadBtn"
                      >
                        CLICK TO UPLOAD
                      </button>
                      <span className="tooltiptext   tooltip-bottom" style={{top:"47px",left:"89px",width:"auto"}}>
                    Upload Document
                  </span>
                  </div>
                      <p
                        style={{
                          textAlign: "left",
                          paddingLeft: "10px",
                          fontSize: "16px",
                        }}
                      >
                        <br />
                        <span>Supported file format PDF only upto 2MB</span>
                      </p>
                      <div className="fileupload-resume-startup">
                        <input
                          className="resume-upload"
                          type="file"
                          id="fileUpload-resume"
                          required
                          name="uploadResume"
                          onChange={handleInputChange}
                          accept="application/pdf"
                          style={{ display: "none" }}
                          // onBlur={onBlur}
                        />
                      </div>
                    </div>
                                     {fileData && fileData?.uploadResume !== null && (
                      <div style={{ marginBottom: "50px" }}>
                        <div className="file-name" style={{ float: "left" }}>
                          {fileData?.uploadResume?.name}{" "}
                          <span
                            style={{ marginLeft: "10px" }}
                            onClick={() => removeFile("uploadResume")}
                          >
                            {" "}
                            X{" "}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                  {/* <div
                    style={{ textAlign: "left" }}
                    className="col col-lg-7 col-md-6 col-sm-12  col-12 "
                  >
                       <div className="uploadDocumentModal">
                  <input
                    className="uploadDocumentInput"
                    type="file"
                    id="fileUpload-resume"
                    required
                    name="uploadResume"
                    onChange={handleInputChange}
                    // accept="application/pdf"
                  />
                </div>
                {
                    {(fileData && fileData?.uploadResume !== null) &&(
              <div style={{ marginBottom: "50px" }}>
                <div className="file-name" style={{ float: "left" }}>
                  {fileData?.uploadResume?.name}{" "}
                  <span
                    style={{ marginLeft: "10px" }}
                    onClick={() => removeFile("uploadResume")}
                  >
                    {" "}
                    X{" "}
                  </span>
                </div>
              </div>
                )}
                  </div> */}
                </div>
                <div className="row pb-4 ">
                  <div className="col col-lg-1 col-md-1 col-sm-12 col-12 numdata d-flex justify-content-center">
                    4
                  </div>
                  <div className="col col-lg-4 col-md-5 col-sm-10 col-12 feedback-headdding ">
                    SESSION HOURS*
                  </div>
                  <div
                    style={{ textAlign: "left", fontFamily: "Montserrat" }}
                    className="col col-lg-7 col-md-6 col-sm-12  col-12 "
                  >
                    <Select
                      // defaultValue={colourOptions[2]}
                      options={hoursData}
                      styles={customStyles}
                      placeholder="Select the duration"
                      onChange={(e) => {
                        setSessionHours(e.label);
                      }}
                    />
                    {errorVisible && (
                      <div className="login-error-msg mt-2">
                        Please enter all details*
                      </div>
                    )}
                    {/* <Select
              required={true}
              id="sessionHours"
              // label="Gender*"
              variant="outlined"
              fullWidth
              margin="normal"
              name="sessionHours"
              styles={customStyles}
              value={sessionHours.hours}
              // defaultValue={genderOption}
              // onChange={handleInputChange}
              onChange={(e) => {
                // setGender(e.value);
                // 
                setSessionHours((user) => {
                  return { ...user, hours: e.label };
                });
              }}
              // onChange={(e) => {
              //   setSessionHours(e.label);
              // }}
              options={hoursData}
              placeholder="Select the duration"
            /> */}
                    {/* <Select 
                  placeholder="Select the duration"
                  options={hoursData}
                  styles={customStyles}
                  value={sessionHours}
                  onChange={(e) => {
                    setSessionHours(e.label);
                    // setError(null);
                  }}
                  /> */}
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-center feedBackFooterFix2">
            <div className="d-flex justify-between feedBackFooterFix">
              <div>
                <Button
                  onClick={handleClose}
                  text="BACK"
                  className="modalButton3 doc-upload"
                ></Button>
              </div>
              <div>
                <Button
                  onClick={handleSubmit}
                  text="SAVE & SUBMIT"
                  className="modalButton3 doc-uploadnext"
                ></Button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
  };
};

export default connect(mapStateToProps, { postSessionSummaryData })(
  withRouter(SessionsMomModal)
);
